module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrighta"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Published by The University of Georgia Press"), _c('br'), _vm._v("\n  Athens, Georgia 30602"), _c('br'), _vm._v("\n  © 1994 by Chrisanne Fuhrman"), _c('br'), _vm._v("\n  All rights reserved"), _c('br'), _vm._v("\n  Designed by Erin Kirk New"), _c('br'), _vm._v("\n  Set in 10.5 on 14 Berkeley Old Style Medium"), _c('br'), _vm._v("\n  by Tseng Information Systems, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The paper in this book meets the guidelines for permanence"), _c('br'), _vm._v("\n  and durability of the Committee on Production Guidelines"), _c('br'), _vm._v("\n  for Book Longevity of the Council on Library Resources.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Printed in Canada")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("08 09 10 11 12 P 11 10 9 8 7")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the hardcover edition of this book as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("\n  Fuhrman, Chris."), _c('br'), _vm._v("\n  The dangerous lives of altar boys : a novel / by Chris Fuhrman"), _c('br'), _vm._v("\n  viii, 187 p. ; 23 cm."), _c('br'), _vm._v("\n  ISBN 0-8203-1632-6 (alk. paper)"), _c('br'), _vm._v("\n  1. Boys—Fiction."), _c('br'), _vm._v("\n  2. Catholics—Fiction."), _c('br'), _vm._v("\n  3. Savannah (Ga.)—Fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("PS3556.U3245 D36 1994")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("813’.54—dc20    93-41113")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Paperback ISBN-13: 978-0-8203-2338-1"), _c('br'), _vm._v("\n  ISBN-10: 0-8203-2338-1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("British Library Cataloging-in-Publication Data available")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("“Thirteen,” “The Usual Gang of Idiots,” and “A Priest with a"), _c('br'), _vm._v("\n  Girlfriend” were first published in "), _c('em', [_vm._v("Columbia: A Magazine of"), _c('br'), _vm._v("\n  Poetry & Prose,")]), _vm._v(" no. 17 (Fall 1991): 201-30.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('strong', [_vm._v("ISBN for this digital edition: 978-0-8203-3585-8")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55681477","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/copyright.vue
// module id = 66
// module chunks = 0